module.exports = __webpack_public_path__ + "img/fj.2ec8af9e.svg";